import React from "react";
import PropTypes from "prop-types";

/**
 * Reusable Check Icon for checklist perks and bullet items.
 */
export const CheckIcon = ({
  className = "tw-w-4 tw-h-4 tw-text-white/50 tw-flex-shrink-0 tw-mt-1",
  strokeWidth = 1.8,
}) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M13.3334 4L6.00008 11.3333L2.66675 8"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

CheckIcon.propTypes = {
  className: PropTypes.string,
  strokeWidth: PropTypes.number,
};

CheckIcon.defaultProps = {
  className: "tw-w-4 tw-h-4 tw-text-white/50 tw-flex-shrink-0 tw-mt-1",
  strokeWidth: 1.8,
};
